import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import { navigate } from '~/router';

import { UserRole } from '~/apps/shared/consts';
import SideSubMenu from '~/common/menu/SideSubMenu';


function SettingsSubMenuContainer(props) {
  const { route } = props;

  let items = [
    {
      text: 'Account',
      isActive: route.name.startsWith('receiver.admin.settings.account'),
      onClick: (e) => navigate('receiver.admin.settings.account'),
    },
    {
      text: 'Support',
      isActive: route.name.startsWith('receiver.admin.settings.support'),
      onClick: (e) => navigate('receiver.admin.settings.support'),
    },
    {
      text: 'Team',
      isActive: route.name.startsWith('receiver.admin.settings.team'),
      onClick: (e) => navigate('receiver.admin.settings.team'),
    },
    {
      text: 'Legal',
      isActive: route.name.startsWith('receiver.admin.settings.legal'),
      onClick: (e) => navigate('receiver.admin.settings.legal'),
    },
    {
      text: 'Logout',
      isActive: route.name.startsWith('logout'),
      onClick: (e) => navigate('logout'),
    },
  ];

  return (
    <SideSubMenu items={items} />
  );
}


const mapStateToProps = (state) => {
  const routeNodeSelector = createRouteNodeSelector('receiver.admin');

  return {
    auth: state.shared.auth,
    ...routeNodeSelector(state),
  }
};

export default connect(mapStateToProps)(SettingsSubMenuContainer);
